import { render } from "./FileGallery.vue?vue&type=template&id=24aa96b6&scoped=true"
import script from "./FileGallery.vue?vue&type=script&lang=js"
export * from "./FileGallery.vue?vue&type=script&lang=js"

import "./FileGallery.vue?vue&type=style&index=0&id=24aa96b6&scoped=true&lang=css"
/* custom blocks */
import block0 from "./FileGallery.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24aa96b6"]])

export default __exports__